/** @internalapi @module path */ /** */
export * from './pathNode';
export * from './pathUtils';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uirouter/core/lib-esm/path/index.js
// module id = 759
// module chunks = 2